import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-download-button',
  templateUrl: './download-excel-template-button.component.html',
  styleUrls: ['./download-excel-template-button.component.css']
})
export class DownloadButtonComponent implements OnInit {

  @Output() downloadClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  onDownloadClick(): void {
    this.downloadClicked.emit('CreateLocationTemplate.xlsx'); 
  }

}
